var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.hasPermission('metabase.view') ? _c('div', [_c('page-title', {
    attrs: {
      "title": "Dashboard",
      "icon": "pe-7s-display2"
    }
  }), _vm.isLoading ? _c('b-row', [_c('b-col', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)], 1) : _c('b-row', [_c('b-col', [_c('metabase', {
    attrs: {
      "identifier": "dashboard",
      "parameters": {
        location_id: _vm.locationId
      }
    }
  })], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }